import { indexData } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          按主题整理的精选片单，满足不同观影口味的需求
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors group"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-xs text-white/90 font-medium bg-black/30 backdrop-blur-sm px-2 py-0.5 rounded whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-xs md:text-sm font-heading font-bold text-foreground-900 line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}